/* FONDOS CON DEGRADADO Y TEXTURA para el editor libre (plantillas de la taza). Es el MISMO motor que usan las banderas
 * (bandera-editor.js): mismas fórmulas de degradado y mismas texturas, copiadas aquí para poder usarlas sin cargar el editor de
 * banderas. Si se cambia una textura allí, hay que cambiarla también aquí.
 *
 *   FondosLienzo.pintar(canvas, wCm, hCm, { c: ['#fff', '#f9a8c0'], t: 'v'|'d'|'r', tx: 'puntos', f: 1 })
 *   FondosLienzo.texturas  → [[clave, nombre], …]
 * El lienzo se dibuja en cm (escala = ancho del lienzo / wCm). */
(function () {
  'use strict';
  function dirDeg(w, h, tipo) { return tipo === 'd' ? [w, h * 0.4] : [0, 1]; }
  function rellenarDeg(ctx, w, h, cols, tipo) {
    ctx.save();
    var g, n = cols.length;
    if (tipo === 'r') {
      var rx = w, ry = h * 0.75;
      ctx.translate(w / 2, h * 0.3); ctx.scale(1, ry / rx);
      g = ctx.createRadialGradient(0, 0, 0, 0, 0, rx);
      cols.forEach(function (c, i) { g.addColorStop(i / (n - 1), c); });
      ctx.fillStyle = g; ctx.fillRect(-w, -(h * 0.3 + 10) * rx / ry, w * 2, (h + 20) * rx / ry);
    } else {
      var d = dirDeg(w, h, tipo), hi = d[0] * w + d[1] * h, m = d[0] * d[0] + d[1] * d[1];
      g = ctx.createLinearGradient(0, 0, d[0] * hi / m, d[1] * hi / m);
      cols.forEach(function (c, i) { g.addColorStop(i / (n - 1), c); });
      ctx.fillStyle = g; ctx.fillRect(-10, -10, w + 20, h + 20);
    }
    ctx.restore();
  }
  /* TEXTURAS: dibujos repetidos (puntos, rayas...) que se superponen al fondo con poca opacidad. Son figuras
     en cm, calculadas con la misma fórmula en montaje_bandera.py, así que el archivo final sale igual. */
  var TEXTURAS = [ ['puntos', 'Puntos'], ['rayas', 'Rayas'], ['cuadros', 'Cuadros'], ['zigzag', 'Zigzag'], ['burbujas', 'Burbujas'], ['trama', 'Trama'],
    ['tablero', 'Tablero'], ['rombos', 'Rombos'], ['olas', 'Olas'], ['hexagonos', 'Hexágonos'], ['estrellas', 'Estrellas'], ['camuflaje', 'Camuflaje'],
    ['chevron', 'Chevron'], ['rayos', 'Rayos de sol'], ['hojas', 'Hojas'],
    ['selva', 'Selva'], ['madera', 'Madera'], ['ladrillo', 'Ladrillo'], ['marmol', 'Mármol'], ['agua', 'Agua'], ['nieve', 'Nieve'] ];
  function fr(x) { return x - Math.floor(x); }
  function hs(i, k) { return fr(Math.sin(i * 12.9898 + k * 78.233) * 43758.5453); }
  function orient(p) {       // todos los polígonos con el mismo sentido, para que al juntarlos no se hagan huecos
    var a = 0, n = p.length;
    for (var i = 0; i < n; i++) { var q = p[(i + 1) % n]; a += p[i][0] * q[1] - q[0] * p[i][1]; }
    return a < 0 ? p.reverse() : p;
  }
  function cuad(x0, y0, x1, y1, x2, y2, x3, y3) { return orient([[x0, y0], [x1, y1], [x2, y2], [x3, y3]]); }
  function segq(ax, ay, bx, by, w) {        // trazo fino entre dos puntos
    var dx = bx - ax, dy = by - ay, l = Math.sqrt(dx * dx + dy * dy) || 1, nx = -dy / l * w / 2, ny = dx / l * w / 2;
    return cuad(ax + nx, ay + ny, bx + nx, by + ny, bx - nx, by - ny, ax - nx, ay - ny);
  }
  function texturaCapas(t, W, H, esc) {
    var P = [], C = [], i, j, s, U = Math.min(W, H) * (esc || 1);   // esc < 1: dibujo más pequeño (las banderas usan 1)
    if (t === 'puntos' || t === 'trama') {
      s = U / (t === 'puntos' ? 7 : 9);
      for (j = 0; j * s * 0.866 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var x = (i + (j % 2 ? 0.5 : 0)) * s, y = j * s * 0.866, r = s * 0.13;
        if (t === 'trama') { r = s * 0.5 * Math.pow(Math.min(1, Math.max(0, y / H)), 1.3); if (r < s * 0.03) continue; }
        C.push([x, y, r]);
      }
      return [{ p: P, c: C }];
    }
    if (t === 'rayas') {
      var per = U / 5, wd = per * 0.45;
      for (var c = 0; c < W + H + per; c += per) P.push(cuad(c, 0, c + wd, 0, c + wd - H, H, c - H, H));
      return [{ p: P, c: C }];
    }
    if (t === 'cuadros') {
      s = U / 6; var V = [], Hh = [];
      for (i = 0; i * s * 2 < W + s; i++) V.push(cuad(i * s * 2, 0, i * s * 2 + s, 0, i * s * 2 + s, H, i * s * 2, H));
      for (j = 0; j * s * 2 < H + s; j++) Hh.push(cuad(0, j * s * 2, W, j * s * 2, W, j * s * 2 + s, 0, j * s * 2 + s));
      return [{ p: V, c: C }, { p: Hh, c: C }];
    }
    if (t === 'zigzag') {
      s = U / 5; var sp = s * 1.1, g = s * 0.09, am = s * 0.3;
      for (j = 0; j * sp < H + s; j++) for (i = 0; i * s / 2 < W + s; i++) {
        var xa = i * s / 2, xb = xa + s / 2, ya = j * sp + (i % 2 ? am : 0), yb = j * sp + (i % 2 ? 0 : am);
        var dx = xb - xa, dy = yb - ya, l = Math.sqrt(dx * dx + dy * dy), ux = dx / l, uy = dy / l, nx = -uy * g / 2, ny = ux * g / 2, e = g / 2;
        P.push(cuad(xa - ux * e + nx, ya - uy * e + ny, xb + ux * e + nx, yb + uy * e + ny, xb + ux * e - nx, yb + uy * e - ny, xa - ux * e - nx, ya - uy * e - ny));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'tablero') {
      s = U / 6;
      for (j = 0; j * s < H + s; j++) for (i = 0; i * s < W + s; i++) if (!((i + j) % 2)) P.push(cuad(i * s, j * s, (i + 1) * s, j * s, (i + 1) * s, (j + 1) * s, i * s, (j + 1) * s));
      return [{ p: P, c: C }];
    }
    if (t === 'rombos') {
      s = U / 4; var rr = s * 0.22;
      for (j = 0; j * s * 0.5 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xr = (i + (j % 2 ? 0.5 : 0)) * s, yr = j * s * 0.5;
        P.push(orient([[xr, yr - rr], [xr + rr, yr], [xr, yr + rr], [xr - rr, yr]]));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'olas') {
      var lam = U / 1.5, am2 = U * 0.05, gw = U * 0.04, sp2 = U * 0.18, nn = Math.ceil(W / (lam / 12)) + 1;
      for (j = 0; j * sp2 < H + sp2; j++) {
        var top = [], bot = [];
        for (i = 0; i <= nn; i++) { var xw = i * lam / 12, yw = j * sp2 + am2 * Math.sin(2 * Math.PI * xw / lam); top.push([xw, yw]); bot.push([xw, yw + gw]); }
        P.push(orient(top.concat(bot.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'hexagonos') {
      s = U / 5; var R = s * 0.5;
      for (j = 0; j * s * 0.866 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xh = (i + (j % 2 ? 0.5 : 0)) * s, yh = j * s * 0.866, hx = [];
        for (var k = 0; k < 6; k++) hx.push([xh + R * Math.cos(Math.PI / 3 * k + Math.PI / 6), yh + R * Math.sin(Math.PI / 3 * k + Math.PI / 6)]);
        P.push(orient(hx));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'estrellas') {
      s = U / 4; var Ro = s * 0.17, Ri = Ro * 0.42;
      for (j = 0; j * s * 0.5 < H + s; j++) for (i = -1; i * s < W + s; i++) {
        var xs = (i + (j % 2 ? 0.5 : 0)) * s, ys = j * s * 0.5, st = [];
        for (var k2 = 0; k2 < 10; k2++) { var rad = k2 % 2 ? Ri : Ro, an = -Math.PI / 2 + Math.PI / 5 * k2; st.push([xs + rad * Math.cos(an), ys + rad * Math.sin(an)]); }
        P.push(orient(st));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'camuflaje') {
      s = U / 5; var nb = Math.round(W * H / (s * s) * 1.1);
      for (i = 0; i < nb; i++) C.push([fr(Math.sin(i * 12.9898 + 3.3) * 43758.5453) * W, fr(Math.sin(i * 78.233 + 9.1) * 43758.5453) * H,
        s * (0.2 + 0.35 * fr(Math.sin(i * 39.346 + 2.2) * 43758.5453))]);
      return [{ p: P, c: C }];
    }
    if (t === 'chevron') {
      s = U / 3; var sp3 = s * 0.9, g3 = s * 0.2, am3 = s * 0.4;
      for (j = 0; j * sp3 < H + s; j++) for (i = 0; i * s / 2 < W + s; i++) {
        var xa2 = i * s / 2, xb2 = xa2 + s / 2, ya2 = j * sp3 + (i % 2 ? am3 : 0), yb2 = j * sp3 + (i % 2 ? 0 : am3);
        var dx2 = xb2 - xa2, dy2 = yb2 - ya2, l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2), ux2 = dx2 / l2, uy2 = dy2 / l2, nx3 = -uy2 * g3 / 2, ny3 = ux2 * g3 / 2, e2 = g3 / 2;
        P.push(cuad(xa2 - ux2 * e2 + nx3, ya2 - uy2 * e2 + ny3, xb2 + ux2 * e2 + nx3, yb2 + uy2 * e2 + ny3, xb2 + ux2 * e2 - nx3, yb2 + uy2 * e2 - ny3, xa2 - ux2 * e2 - nx3, ya2 - uy2 * e2 - ny3));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'rayos') {
      var cx0 = W / 2, cy0 = H * 0.08, RR = 2 * (W + H), nr = 22;
      for (i = 0; i < nr; i++) {
        var a0 = Math.PI * i / nr, a1 = a0 + Math.PI / nr * 0.5;
        P.push(orient([[cx0, cy0], [cx0 + RR * Math.cos(a0), cy0 + RR * Math.sin(a0)], [cx0 + RR * Math.cos(a1), cy0 + RR * Math.sin(a1)]]));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'hojas') {
      s = U / 4; var nh = Math.round(W * H / (s * s) * 1.6);
      for (i = 0; i < nh; i++) {
        var hx = hs(i, 3.1) * W, hy = hs(i, 5.7) * H, ha = hs(i, 9.3) * 6.2832, hL = s * (0.55 + 0.45 * hs(i, 1.7)), lado = [], lado2 = [], ca = Math.cos(ha), sa = Math.sin(ha);
        for (var q = 0; q <= 8; q++) {
          var tt = q / 8, al = hL * (tt - 0.5), wd = 0.17 * hL * Math.sin(Math.PI * tt);
          lado.push([hx + al * ca - wd * sa, hy + al * sa + wd * ca]); lado2.push([hx + al * ca + wd * sa, hy + al * sa - wd * ca]);
        }
        P.push(orient(lado.concat(lado2.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'selva') {                     // hojas grandes de banano con sus nervios (2 capas: hoja y nervios)
      var nl = Math.round(W * H / (U * U) * 2.4) + 5, LA = [], VE = [];
      for (i = 0; i < nl; i++) {
        var lx = hs(i, 2.1) * W, ly = hs(i, 4.3) * H, la = -0.9 + (hs(i, 6.7) - 0.5) * 0.9 + (hs(i, 8.1) > 0.5 ? Math.PI : 0);
        var LL = U * (0.7 + 0.7 * hs(i, 1.3)), ca = Math.cos(la), sa = Math.sin(la), l1 = [], l2 = [];
        for (j = 0; j <= 12; j++) {
          var tt = j / 12, al = LL * (tt - 0.5), wd = 0.19 * LL * Math.pow(Math.sin(Math.PI * tt), 0.8);
          l1.push([lx + al * ca - wd * sa, ly + al * sa + wd * ca]); l2.push([lx + al * ca + wd * sa, ly + al * sa - wd * ca]);
        }
        LA.push(orient(l1.concat(l2.reverse())));
        VE.push(segq(lx - 0.5 * LL * ca, ly - 0.5 * LL * sa, lx + 0.5 * LL * ca, ly + 0.5 * LL * sa, LL * 0.014));
        for (j = 1; j <= 7; j++) {
          var tv = 0.12 + j * 0.11, ax = lx + LL * (tv - 0.5) * ca, ay = ly + LL * (tv - 0.5) * sa, tx2 = tv + 0.08;
          var wv = 0.19 * LL * Math.pow(Math.sin(Math.PI * tv), 0.8) * 0.92;
          [1, -1].forEach(function (sg) {
            VE.push(segq(ax, ay, lx + LL * (tx2 - 0.5) * ca - sg * wv * sa, ly + LL * (tx2 - 0.5) * sa + sg * wv * ca, LL * 0.007));
          });
        }
      }
      return [{ p: LA, c: C }, { p: VE, c: C }];
    }
    if (t === 'madera') {                    // vetas largas y onduladas
      var spm = U * 0.05;
      for (j = 0; j * spm < H + spm; j++) {
        var lam2 = U * (1.2 + 1.5 * hs(j, 1.1)), am = U * (0.01 + 0.03 * hs(j, 2.2)), ph = hs(j, 3.3) * lam2, th = U * (0.004 + 0.01 * hs(j, 4.4));
        var nn2 = Math.ceil(W / (lam2 / 12)) + 1, tp = [], bt = [];
        for (i = 0; i <= nn2; i++) { var xw = i * lam2 / 12, yw = j * spm + am * Math.sin(2 * Math.PI * (xw + ph) / lam2); tp.push([xw, yw]); bt.push([xw, yw + th]); }
        P.push(orient(tp.concat(bt.reverse())));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'ladrillo') {
      var bh = U / 12, bw = U / 5.5, gg = U * 0.012;
      for (j = 0; j * bh < H + bh; j++) for (i = -1; i * bw < W + bw; i++) {
        var bx = (i + (j % 2 ? 0.5 : 0)) * bw, by = j * bh;
        P.push(cuad(bx + gg, by + gg, bx + bw - gg, by + gg, bx + bw - gg, by + bh - gg, bx + gg, by + bh - gg));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'marmol') {                    // vetas que serpentean
      var nm = Math.round(W * H / (U * U) * 6) + 4;
      for (i = 0; i < nm; i++) {
        var mx = hs(i, 2.7) * W, my2 = hs(i, 3.9) * H, an = hs(i, 5.1) * 6.2832, wd0 = U * (0.012 + 0.02 * hs(i, 6.3)), ps = [[mx, my2]];
        for (j = 0; j < 18; j++) { an += (hs(i * 40 + j, 7.7) - 0.5) * 0.9; mx += Math.cos(an) * U * 0.09; my2 += Math.sin(an) * U * 0.09; ps.push([mx, my2]); }
        for (j = 0; j < 18; j++) P.push(segq(ps[j][0], ps[j][1], ps[j + 1][0], ps[j + 1][1], wd0 * (1 - j / 18) + 0.001));
      }
      return [{ p: P, c: C }];
    }
    if (t === 'agua') {                      // ondas concéntricas
      var na = Math.round(W * H / (U * U) * 0.8) + 1;
      for (i = 0; i < na; i++) {
        var ax0 = hs(i, 2.2) * W, ay0 = hs(i, 4.4) * H;
        for (var rk = 0; rk < 4; rk++) {
          var rad = U * (0.12 + 0.17 * rk);
          for (j = 0; j < 28; j++) {
            var a0 = 6.2832 * j / 28, a1 = 6.2832 * (j + 1) / 28;
            P.push(segq(ax0 + rad * Math.cos(a0), ay0 + rad * Math.sin(a0), ax0 + rad * Math.cos(a1), ay0 + rad * Math.sin(a1), U * 0.012));
          }
        }
      }
      return [{ p: P, c: C }];
    }
    if (t === 'nieve') {
      var nn3 = Math.round(W * H / (U * U) * 45);
      for (i = 0; i < nn3; i++) C.push([hs(i, 2.3) * W, hs(i, 4.1) * H, U * (0.01 + 0.02 * hs(i, 6.2) * (hs(i, 8.4) > 0.85 ? 2.5 : 1))]);
      return [{ p: P, c: C }];
    }
    if (t === 'burbujas') {
      s = U / 5; var n = Math.round(W * H / (s * s) * 2.2);
      for (i = 0; i < n; i++) C.push([fr(Math.sin(i * 12.9898) * 43758.5453) * W, fr(Math.sin(i * 78.233 + 1.7) * 43758.5453) * H,
        s * (0.06 + 0.22 * Math.pow(fr(Math.sin(i * 39.346 + 5.1) * 43758.5453), 2))]);
      return [{ p: P, c: C }];
    }
    return [];
  }
  function luminosidad(hex) {
    var n = parseInt(hex.slice(1), 16); return (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
  }
  function pintarTextura(ctx, W, H, tx) {
    ctx.save(); ctx.fillStyle = tx.c; ctx.globalAlpha = tx.a;
    texturaCapas(tx.t, W, H, tx.e).forEach(function (L) {
      ctx.beginPath();
      L.p.forEach(function (q) { q.forEach(function (pt, i) { if (i) ctx.lineTo(pt[0], pt[1]); else ctx.moveTo(pt[0], pt[1]); }); ctx.closePath(); });
      L.c.forEach(function (c) { ctx.moveTo(c[0] + c[2], c[1]); ctx.arc(c[0], c[1], c[2], 0, 6.2832); });
      ctx.fill();
    });
    ctx.restore();
  }

  var DEGRADADOS = [
    { c: ['#fbbf24', '#e31b23'], t: 'v' }, { c: ['#22d3ee', '#1e3a8a'], t: 'v' }, { c: ['#ec4899', '#4c1d95'], t: 'v' }, { c: ['#a3e635', '#14532d'], t: 'v' },
    { c: ['#f5f5f5', '#6b7280'], t: 'v' }, { c: ['#facc15', '#f97316'], t: 'v' }, { c: ['#60a5fa', '#7c3aed'], t: 'v' }, { c: ['#e31b23', '#450a0a'], t: 'v' },
    { c: ['#fde047', '#f97316', '#be123c'], t: 'v' }, { c: ['#22d3ee', '#3b82f6', '#7c3aed'], t: 'v' },
    { c: ['#34d399', '#0ea5e9', '#1e3a8a'], t: 'v' }, { c: ['#f9a8d4', '#c084fc', '#6366f1'], t: 'v' },
    { c: ['#f97316', '#ec4899'], t: 'd' }, { c: ['#06b6d4', '#6366f1'], t: 'd' }, { c: ['#fde047', '#22c55e'], t: 'd' }, { c: ['#1e1b4b', '#a21caf'], t: 'd' },
    { c: ['#fde68a', '#f97316'], t: 'r' }, { c: ['#60a5fa', '#1e3a8a'], t: 'r' }, { c: ['#ffffff', '#9ca3af'], t: 'r' }, { c: ['#fca5a5', '#7f1d1d'], t: 'r' }
  ];

  function pintar(cv, wCm, hCm, o) {
    var ctx = cv.getContext('2d'), k = cv.width / wCm, cols = o.c && o.c.length > 1 ? o.c : [o.c ? o.c[0] : '#ffffff', o.c ? o.c[0] : '#ffffff'];
    ctx.save(); ctx.scale(k, k);
    ctx.fillStyle = cols[0]; ctx.fillRect(0, 0, wCm, hCm);
    rellenarDeg(ctx, wCm, hCm, cols, o.t || 'v');
    if (o.tx) {
      var claro = (luminosidad(cols[0]) + luminosidad(cols[cols.length - 1])) / 2 < 0.55, f = o.f || 1;
      pintarTextura(ctx, wCm, hCm, { t: o.tx, c: claro ? '#ffffff' : '#000000', a: (claro ? 0.18 : 0.13) * f, f: f, e: o.e });
    }
    ctx.restore();
    return cv;
  }
  window.FondosLienzo = { pintar: pintar, texturas: TEXTURAS, degradados: DEGRADADOS, luminosidad: luminosidad };
})();
